import type { KeyboardEvent, RefObject } from "react";
import { useCallback, useRef, useState } from "react";

import type { MachineGroup } from "@/schemas";

interface UseScanToTriggerInputParams {
	currentMachineGroup: MachineGroup | null | undefined;
	triggerJobByLPN: (machineGroup: MachineGroup, lpn: string) => void | Promise<void>;
}

interface UseScanToTriggerInputReturn {
	onKeyUp: (event: KeyboardEvent<HTMLInputElement>) => Promise<void>;
	inputRef: RefObject<HTMLInputElement>;
	isLoading: boolean;
}

export const useScanToTriggerInput = ({
	currentMachineGroup,
	triggerJobByLPN,
}: UseScanToTriggerInputParams): UseScanToTriggerInputReturn => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [isLoading, setIsLoading] = useState(false);

	const handleKeyUp = useCallback(
		async (event: KeyboardEvent<HTMLInputElement>) => {
			if (event.key === "Enter" && currentMachineGroup) {
				setIsLoading(true);
				try {
					await triggerJobByLPN(currentMachineGroup, event.currentTarget.value);
				} catch (e) {
					console.error("Error invoking scan import: ", e);
				} finally {
					setIsLoading(false);
					if (inputRef.current) {
						inputRef.current.value = "";
						setTimeout(() => inputRef.current?.focus(), 200);
					}
				}
			}
		},
		[currentMachineGroup, triggerJobByLPN],
	);

	return { onKeyUp: handleKeyUp, inputRef, isLoading };
};
